import React from 'react';
import { Col, Container, Row } from 'reactstrap';
import { withTranslation } from 'react-i18next';
import PropTypes from 'prop-types';
import showResults from '../Form/Show';
import CallAssistDefault from './components/CallAssistDefault.jsx';

const FileUploadCall = ({ t }) => (
  <Container>
    <Row>
      <Col md={12}>
        <h3 className="page-title">{"Call Assist Upload"}</h3>
       </Col>
    </Row>
    <CallAssistDefault onSubmit={showResults} />
  </Container>
);
FileUploadCall.propTypes = {
  t: PropTypes.func.isRequired,
};

export default withTranslation('common')(FileUploadCall);
